import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet, interactiveTransition } from 'modules/v2/foundation/theme';
import { getStylesBySelected } from './utils/getStylesBySelected';
const ButtonStyling = css `
  outline: none;
  padding: ${themeGet('spacing.sm')};
  min-width: ${themeGet('spacing.3xl')};
  min-height: ${themeGet('spacing.3xl')};
  box-sizing: border-box;
  background-color: transparent;
  border: none;
  border-radius: ${themeGet('borderRadius.circle')};

  &:focus-visible {
    box-shadow: 0 0 0 ${pxToRem(4)} ${themeGet('colors.focus.primary')};
  }

  &:hover {
    background-color: ${themeGet('colors.primary.50')};
  }

  &:disabled {
    background-color: transparent;
  }

  ${interactiveTransition};
`;
export const PaginationPage = styled.button `
  ${ButtonStyling};
  color: ${themeGet('colors.text.100')};

  &:disabled {
    color: ${themeGet('colors.disabled.200')};
  }

  ${(props) => props.$selected && getStylesBySelected()};
`;
export const PaginationArrowButton = styled.button `
  ${ButtonStyling};
  & svg {
    color: ${themeGet('colors.text.300')};
  }

  &:disabled svg {
    color: ${themeGet('colors.disabled.200')};
  }
`;
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${themeGet('spacing.sm')};
`;
